import React from 'react'
import styled from 'styled-components'
import placeHolderImage from '../../assets/img/meetingroom-placeholder-essential.png'
import {_L, useLocaleState} from '../../context/LocaleContext'

const MeetingSpace = styled.div`
  margin: 12px;
  width: 344px;
  height: 280px;
  border-radius: 6px;
  background-color: #ffffff;
  box-shadow: 0 11px 43px 0 rgba(0, 0, 0, 0.05);
  cursor: pointer;
  box-sizing: border-box;
`

const ImageContainer = styled.div`
  width: 100%;
  height: 188px;
  box-sizing: border-box;
`

const StyledImage = styled.div`
  background-image: url(${props => props.url || placeHolderImage});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 6px 6px 0 0;
  height: 100%;
  width: 100%;
`

const TitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 92px;
  box-sizing: border-box;
  overflow: hidden;
`

const StyledTitle = styled.div`
  font-size: 18px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: -0.3px;
  color: #000000;
  width: 100%;
  text-align: center;
`

const StyledAvailable = styled.div`
  opacity: 0.65;
  font-size: 16px;
  font-weight: 600;
  letter-spacing: -0.4px;
  text-align: center;
  color: #a4a9b7;
`

const RoomCard = ({room, onClick}) => {
  const {url, rmName, fl_id, rm_id} = room
  const localeState = useLocaleState()
  return (
    <MeetingSpace onClick={() => onClick(room)}>
      <ImageContainer>
        <StyledImage data-testid="room-image" url={url} />
      </ImageContainer>
      <TitleContainer>
        <StyledTitle data-testid="room-title">
          {rmName} {fl_id} - {rm_id}
        </StyledTitle>
        <StyledAvailable data-testid="room-available">
          {_L({key: 'Available', localeState})}
        </StyledAvailable>
      </TitleContainer>
    </MeetingSpace>
  )
}

export default RoomCard
